"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultProps = exports.propTypes = exports.config = void 0;

var _spauiUtils = require("@tencent/spaui-utils");

/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2019, a Tencent company. All rights reserved.
 */

/**
 * @fileoverview 组件参数配置
 */

/**
 * Collapse 接口参数
 * @alias CollapseProps
 * @description 用于折叠/展开的内容区域。
 * @property {titleline} 默认支持参数
 * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
 * @property {titleline} 基础属性
 * @property {bool} [open=false] 是否展开
 * @property {bool} [transitionAppear=true] 是否需要动画
 * @property {func} [onTransitionEnd] 动画结束回调<br />onTransitionEnd(dom)
 * @property {bool} [updateTimeout=4] 计算位置延迟时间(ms)
 * @example
 * children 只能是一个元素
 */
var config = {
  open: {
    type: _spauiUtils.PropTypes.bool.isRequired,
    defaultValue: false
  },
  transitionAppear: {
    type: _spauiUtils.PropTypes.bool,
    defaultValue: true
  },
  onTransitionEnd: {
    type: _spauiUtils.PropTypes.func
  },
  updateTimeout: {
    type: _spauiUtils.PropTypes.number,
    defaultValue: 4
  }
}; // 转化成PureComponent组件的配置

exports.config = config;
var configData = (0, _spauiUtils.formatProps)(config); // 导出

var propTypes = configData.propTypes;
exports.propTypes = propTypes;
var defaultProps = configData.defaultProps;
exports.defaultProps = defaultProps;
var _default = {
  config: config,
  propTypes: propTypes,
  defaultProps: defaultProps
};
exports["default"] = _default;